import { css } from '@emotion/react';
import { p2r, Primary, Secondary } from '../../../styles/fonts';
import { colors, breakpoints } from '../../../styles';

const heightCell = p2r(360);

const styles = (backgroundColor) => css`
  .hero-section {
    position: relative;
    display: grid;
    grid-template-columns: 50% 50%;
  }

  .hero-section__content {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: ${heightCell};
    padding: ${p2r(54)} 44px ${p2r(53)} 45px;
    color: ${colors.white};
    background-color: ${backgroundColor};

    .download-button-top {
      position: absolute;
      top: 92%;
      right: 50%;
      bottom: 0;
      left: 8%;
    }
  }

  .hero-section__content .text-header {
    max-width: 423px;
  }

  .plug-container {
    width: 512px;
    min-height: ${p2r(360)};
    background-color: ${colors.darkGray};
  }

  .plug-container-mobile {
    display: none;
    width: 100%;
    min-height: ${p2r(379)};
    background-color: ${colors.darkGray};
  }

  .hero-section__subtitle {
    width: 100%;
    max-width: 323px;
    font: normal normal 300 ${p2r(18)} / ${p2r(24)} ${Primary};
  }

  .hero-section-page__image-wrapper {
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  .hero-section__image {
    width: 100%;
    height: 100%;
    min-height: ${heightCell};
    object-fit: cover;

    &--mobile {
      display: none;
    }
  }

  @media (max-width: ${breakpoints.tablet}px) {
    .text-header {
      font: normal normal bold ${p2r(36)} / ${p2r(42)} ${Secondary};
    }

    .hero-section__subtitle {
      max-width: 100%;
    }

    .text-subtitle {
      padding-left: 0;
      font: normal normal 300 ${p2r(18)} / ${p2r(24)} ${Primary};
    }

    .hero-section__content,
    .hero-section__image {
      height: 100%;
      min-height: ${p2r(290)};
    }

    .plug-container {
      display: none;
    }

    .plug-container-mobile {
      display: block;
    }
  }

  @media (max-width: ${breakpoints.smallTablet}px) {
    .text-header {
      font: normal normal bold ${p2r(28)} / ${p2r(42)} ${Secondary};
    }
  }

  @media (max-width: ${breakpoints.hugeMobile}px) {
    .hero-section {
      display: flex;
      flex-direction: column;

      .download-button-top {
        left: 5%;
      }
    }

    .hero-section__content {
      min-height: ${p2r(246)};
      padding: ${p2r(64)} 55px ${p2r(32)} 16px;
    }

    .hero-section__content .text-header {
      max-width: 343px;
      font: normal normal bold ${p2r(36)} / ${p2r(42)} ${Secondary};
    }

    .hero-section__image {
      display: none;

      &--mobile {
        display: block;
        width: 100%;
      }
    }
  }
`;

export default styles;
